import CustomerBase from "./CustomerBase";
import ICustomer from "./ICustomer";
import IIncome from "@/module/main/dto/customer/IIncome";
import IAmount from "@/module/main/dto/IAmount";
import IAddressFlags from "@/module/main/dto/customer/IAddressFlags";
import IBankAccount from "@/module/main/dto/customer/IBankAccount";
import IPrimaryPersonalDocument from "@/module/main/dto/customer/IPrimaryPersonalDocument";
import ISecondaryPersonalDocument from "@/module/main/dto/customer/ISecondaryPersonalDocument";
import Cohabitation from "@/module/main/dto/customer/CohabitationEnum";
import Education from "@/module/main/dto/customer/EducationEnum";
import HousingTenure from "@/module/main/dto/customer/HousingTenureEnum";

export default class Customer extends CustomerBase implements ICustomer {
    constructor(
        public identificationNumber?: string,
        public phone?: string,
        public email?: string,
        public firstName?: string,
        public lastName?: string,
        public income?: IIncome,
        public householdIncome?: IAmount,
        public expenses?: IAmount,
        public cohabitation?: Cohabitation,
        public education?: Education,
        public housingTenure?: HousingTenure,
        public housingZipCode?: string,
        public birthplace?: string,
        public childrenCount?: number,
        public nationality?: string,
        public politicallyExposed?: boolean,
        public addresses?: IAddressFlags[],
        public bankAccount?: IBankAccount,
        public primaryPersonalDocument?: IPrimaryPersonalDocument,
        public secondaryPersonalDocument?: ISecondaryPersonalDocument
    ) {
        super(phone, email, firstName, lastName);
    }
}
